import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";

const TIERS = [
  { num: "T1", title: "Foundational", desc: "Lifestyle interventions: nutrition, movement, sleep hygiene, stress." },
  { num: "T2", title: "Corrective", desc: "Targeted supplements and nutraceuticals based on domain scores." },
  { num: "T3", title: "Medications", desc: "Prescription therapeutics managed by prescribing clinicians." },
  { num: "T4", title: "Advanced", desc: "Peptides and advanced therapies, physician-supervised.", isRed: true },
];

export const FrameworkSection = () => (
  <section id="framework" className="relative z-[1] py-28 lg:py-36 px-6 lg:px-12 overflow-hidden" data-testid="framework-section">
    <div className="logo-watermark-section">
      <img src={ASSETS.logo} alt="" className="logo-glow-intense" />
    </div>
    <div className="max-w-[1200px] mx-auto relative z-[2]">
      <motion.div
        className="bg-[rgba(3,11,24,0.92)] p-8 rounded-xl mb-12 max-w-[600px]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="font-orbitron text-sm font-semibold tracking-[5px] uppercase text-[#60A5FA] mb-4 text-shadow">
          Programs & Protocols
        </div>
        <h2 className="font-orbitron text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[3px] leading-tight mb-5 text-white text-shadow">
          Tiered Interventions
        </h2>
        <p className="font-outfit text-xl font-light leading-relaxed text-white/90">
          Evidence-informed, configurable protocols with triggers and contraindications — tracked over time for outcomes.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {TIERS.map((tier, i) => (
          <motion.div
            key={i}
            className={`tier-card bg-[rgba(10,22,40,0.95)] border-2 ${tier.isRed ? 'border-[#E31837]/50' : 'border-[#3B82F6]/40'} rounded-lg py-10 px-7 text-center`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            data-testid={`tier-${i + 1}`}
          >
            <div className={`font-orbitron text-5xl lg:text-6xl font-black leading-none mb-4 ${tier.isRed ? 'text-[#E31837]' : 'text-[#60A5FA]'}`}>
              {tier.num}
            </div>
            <h3 className="font-orbitron text-lg font-semibold tracking-[2px] uppercase text-white mb-4">
              {tier.title}
            </h3>
            <p className="font-outfit text-lg leading-relaxed text-white/80 font-light">
              {tier.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
